// @Version: 1.0.0
import { Injectable } from "@angular/core";
import { FormGroup, ValidationErrors, ValidatorFn } from "@angular/forms";
import ICheckboxModel from "./checkbox.model";
import { AndOrOptionService } from "src/app/shared/services/and-or-option/and-or-option.service";
import { ANDOROPTION } from "src/app/shared/services/and-or-option/and-or-option.model";


@Injectable({
   providedIn: 'root'
})

export class CustomValidatorsCheckBox {

   constructor (private sAndOrOption: AndOrOptionService) { }

   public isValid (fg: FormGroup, isValidList: string[], values: ICheckboxModel[], attribute_3?: string): ValidatorFn {
      return (): ValidationErrors | null => {
         if (!fg.dirty) return null;
         if (!fg.value) return null;
         if (!isValidList.length || isValidList.length == 0) return null;
         if (Object.keys(fg.controls).filter((element) => fg.get(element)?.value).length == 0 ) return null;
         return this.checkContentWithAttribute3(Object.keys(fg.controls).filter((element) => fg.get(element)?.value).map(key => values[(Number(key))].value.toString()), isValidList, attribute_3) ? null : { valid: true };
      }
   }

   private checkContentWithAttribute3 (content: string[], validValue: string[], attribute_3?: string): boolean {
      if (!validValue || validValue.length == 0) return true;

      switch(attribute_3) {
         case ANDOROPTION.XOR: return this.sAndOrOption.containsOnlyOneXOR(content, validValue);
         case ANDOROPTION.XAND: return this.sAndOrOption.equalsXAND(content, validValue);
         case ANDOROPTION.AND: return this.sAndOrOption.containsAND(content, validValue);
         default: return this.sAndOrOption.containsOneOR(content, validValue);
      }
   }

   public isRequired (fg: FormGroup): ValidatorFn {
      return (): ValidationErrors | null => {
         return Object.keys(fg.controls).filter((element) => fg.get(element)?.value).length == 0 ? { required: true } : null;
      }
   }
}